import HandoffSituationBlock from './HandoffSituationBlock.jsx';
import HandoffPacketBlock from './HandoffPacketBlock.jsx';
import { DetailSections, WorkflowTraceList } from '../shared/index.js';

/**
 * HTL / Client Handoff detail body: the situation, the context packet the agent
 * assembled, and the workflow trace ending in the ownership transfer — so a
 * human can take over or reassign in place. The decision bar (Acknowledge /
 * Reassign) is rendered by HandoffDecision in the sticky footer.
 */
function HandoffBody({ event }) {
  const detail = event.detail ?? {};

  const sections = [
    <HandoffSituationBlock key="situation" detail={detail} situation={event.situation} />,
    detail.packet || detail.agentSummary ? (
      <HandoffPacketBlock
        key="packet"
        packet={detail.packet}
        agentSummary={detail.agentSummary}
      />
    ) : null,
    detail.trace?.length ? (
      <WorkflowTraceList
        key="trace"
        steps={detail.trace}
        reference={detail.traceRef}
        title={detail.workflow}
      />
    ) : null,
  ].filter(Boolean);

  return <DetailSections sections={sections} />;
}

export default HandoffBody;
